import { render, staticRenderFns } from "./AddDrugProcurement.vue?vue&type=template&id=7a3557f2&"
import script from "./AddDrugProcurement.vue?vue&type=script&lang=js&"
export * from "./AddDrugProcurement.vue?vue&type=script&lang=js&"
import style0 from "./AddDrugProcurement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports